// Axion Elite — Scroll Reveal + count-up stats
// Reveal: adds .is-visible to elements with .reveal-on-scroll when they enter the viewport.
// Count-up: animates the leading numeric portion of .stat-countup elements
// from 0 to their authored value when they enter the viewport. Metaobject
// stat fields are free text (e.g. "$1.2M", "87%", or plain prose) — if no
// leading number is found, the element is left exactly as authored.

(function () {
  function initReveal() {
    var els = document.querySelectorAll('.reveal-on-scroll');
    if (!els.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    els.forEach(function (el) { observer.observe(el); });
  }

  function formatNumber(value, decimals, hasComma) {
    var fixed = value.toFixed(decimals);
    if (!hasComma) return fixed;
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function animateCountUp(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/[\d,]+(\.\d+)?/);
    if (!match) return; // no numeric portion — leave the authored text as-is

    var numStr = match[0];
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;

    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + numStr.length);
    var hasComma = numStr.indexOf(',') !== -1;
    var decimals = numStr.indexOf('.') !== -1 ? numStr.split('.')[1].length : 0;
    var duration = 900;
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      el.textContent = prefix + formatNumber(current, decimals, hasComma) + suffix;
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = raw;
      }
    }

    requestAnimationFrame(frame);
  }

  function initCountUp() {
    var els = document.querySelectorAll('.stat-countup');
    if (!els.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return; // authored text is already correct — nothing to do

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCountUp(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    initReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
